module.exports = __webpack_public_path__ + "5c114213/img/search-filter-icon.c4751a52.svg";